<template>
  <div class="rewardList">
    <el-dialog
      :title="$t('list.打赏明细')"
      :visible.sync="showReward"
      width="500px"
      height="400px"
      class="dialog dialog-dark"
      @close="handleClose"
    >
    <template v-if="listRewards.length">
      <ul class="lists" ref="scrollInfinite" @scroll="load" >
        <li v-for="(list,index) in listRewards" :key="index">
          <span class="number" v-if="index+1===1"><img src="../../svg/number1.svg" width="25px" height="21px"/></span>
          <span class="number" v-else-if="index+1===2"><img src="../../svg/number2.svg" width="25px" height="21px"/></span>
          <span class="number" v-else-if="index+1===3"><img src="../../svg/number3.svg" width="25px" height="21px"/></span>
          <span class="number" v-else>{{index+1}}</span>
          <span class="fontColor">{{list.userName}}</span>
          <span class="fontColor">¥{{(list.payPrice/100).toFixed(2)}}</span>
          <span class="fontColor">{{list.updateTime.split(' ')[1].substr(0,5)}}</span>
          <span class="fontColor">{{list.giftName}}</span>
        </li>
      </ul>
      
    </template>
    <template v-else>
    <div class="no-reward">
        <img src="../../svg/no-reward.svg" width="160px"/>
      </div>
    </template>
    </el-dialog>
  </div>
</template>

<script>
import {getRewardRecordList} from "@/api/cvacRequest/api";
export default {
  name: "rewardList",
  data() {
    return {
      listRewards: [],
      total: 0,
      liveId: this.$route.query.liveId,
      pageNum: 1,
      pageSize: 20,
      blank: false
    };
  },
  props: {
    reward: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    confId() {
      return this.$store.getters.confId
    },
    showReward: {
      get() {
        return this.reward;
      },
      set() {
        //   return val;
      },
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
  },
  watch: {
    reward: {
      immediate: true,
      handler(value) {
        if(value){
          this.rewardslists();
        }
      }
    },
  },
  created() {
  },
  methods: {
    handleClose() {
      this.$parent.showRewardList = false;
      // this.listRewards = [];
      // this.total = 0;
    },
    rewardslists() {
      let params = {
        page: this.pageNum,
        limit: this.pageSize,
        liveId: this.liveId,
        payPriceMin: 1,
        orderColumn: ["pay_price desc"],
        confId: this.confId
      };
      getRewardRecordList(params).then((resp) => {
        if (resp.status === 0) {
          if(this.pageNum === 1){
            this.listRewards = resp.data? resp.data.data : [];
            this.total = resp.data? resp.data.amount: 0;
          }else{
            this.listRewards = resp.data ? this.listRewards.concat(resp.data.data) : this.listRewards;
            this.total = resp.data ? (this.total + resp.data.amount) : this.total;
          }
          
          this.$emit('totalWard', this.total);
          if(this.listRewards.length === 0 && this.pageNum === 1){
            this.blank = true;
          }
        }
      });
    },
     load() {
      const scrollInfinite = this.$refs.scrollInfinite;
      const elementHeight = scrollInfinite.getBoundingClientRect().height;
      const scrollTop = scrollInfinite.scrollTop;
      const scrollHeight = scrollInfinite.scrollHeight;
      if (Math.ceil(scrollTop) + Math.ceil(elementHeight) + 5 >= scrollHeight) {
        this.pageNum = this.pageNum + 1;
        if (!this.blank) {
          this.rewardslists();
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/styles/vars";
.dialog .el-dialog {
  background: $dialog-bg-color;
  box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: auto;
}
.dialog .el-dialog__title {
  color: $grey3-color;
  font-size: 16px;
}
</style>
<style scoped lang="scss">
.lists{
  overflow-y: auto;
  height: 300px;
}
.lists li {
  overflow: hidden;
  display: flex;
  align-items: center;
}
.lists li {
  span {
    // float: left;
    width: 150px;
  }
  .number{
    width: 50px;
  }
  
}

.no-reward{
  display:flex;
  justify-content: center;
  align-items: center;
  height: 286px;
  padding-bottom: 55px;
  box-sizing: border-box;
}
/* 设置滚动条样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.2);
  background-color: #999;
}
</style>
